/**
 * Imports for the Autodesk.Viewing.Private namespace
 */


//TODO_TS: stuff from compat/globas/envinit goes into both namespaces because they
//contain a mix of public and private exports,
//make it consistent in client code, then remove one of those
export * from "../compat";
export * from "../globals";
export * from "../envinit";

export * from "../file-loaders/net/private";

// Analytics
export * from "../analytics/interface";
export * from "../analytics/index";


export * from "../resource-loader";
export * from "../globalization/i18init";
export * from "../globalization/langs";

export * from "../logger/Logger";

export * from "../wgs/globals";

export * from "../wgs/render/GroundReflection";
export * from "../wgs/render/GroundShadow";
export * from "../wgs/render/WebGLShader";
export * from "../wgs/render/PhongShader";
export * from "../wgs/render/BasicShader";
export * from "../wgs/render/DecodeEnvMap";
export * from "../wgs/render/ShaderChunks";
export * from "../wgs/render/SAOShader";
export * from "../wgs/render/ShaderPass";
export * from "../wgs/render/CelShader";
export * from "../wgs/render/CopyShader";
export * from "../wgs/render/RenderContextPostProcess";
export * from "../wgs/render/LineStyleDef";
export * from "../wgs/render/HalfFloat";
export * from "../wgs/render/ShaderUtils";
export * from "../wgs/render/WebGLProgram";
export * from "../wgs/render/PrismUtil";
export * from "../wgs/render/ShadowMap";
export * from "../wgs/render/MaterialConverterCommon";
export * from "../wgs/render/MaterialConverter";
export * from "../wgs/render/MaterialManager";
export * from "../wgs/render/RenderContext";
export * from "../wgs/render/WebGLRenderer";
export * from "../wgs/wgpu/Renderer";
export { CategoryHighlightingCompare } from "../wgs/wgpu/post/BlendSettings";
export * from "../wgs/wgpu/utils/ShaderPassWebGPU";
export * from "../wgs/wgpu/utils/UniformGroup.ts";
export * from "../wgs/wgpu/utils/CPUTexture";
export * from "../wgs/wgpu/main/ShaderMaterialWebGPU.js";
export * from "../wgs/wgpu/ShaderExtension";
export * from "../wgs/render/GroundFlags";
export * from "../wgs/memory/BufferManager";

export * from "../wgs/scene/MeshFlags";
export * from "../wgs/scene/RenderFlags";
export * from "../wgs/scene/ResetFlags";
export * from "../wgs/scene/LmvVector3";
export * from "../wgs/scene/LmvMatrix4";
export * from "../wgs/scene/LmvBox3";
export * from "../wgs/scene/VertexEnumerator";
export * from "../wgs/scene/VertexBufferReader";
export * from "../wgs/scene/BoundsCallback";
export * from "../wgs/scene/DeriveTopology";
export * from "../wgs/scene/VBIntersector";
export * from "../wgs/scene/GeometryList";
export * from "../wgs/scene/RenderBatch";
export * from "../wgs/scene/ModelIteratorLinear";
export * from "../wgs/scene/ModelIteratorBVH";
export * from "../wgs/scene/SceneTraversal";
export * from "../wgs/scene/NoOpTraversalController";
export * from "../wgs/scene/BufferGeometry";
export * from "../wgs/scene/BufferGeometryUtils";
export * from "../wgs/scene/RenderScene";
export * from "../wgs/scene/SortedList";
export * from "../wgs/scene/RenderModel";
export * from "../wgs/scene/FrustumIntersector";
export * from "../wgs/scene/FragmentIterator";
export * from "../wgs/scene/FragmentList";
export * from "../wgs/scene/InstanceTree";
export * from "../wgs/scene/InstanceTreeStorage";
export * from "../wgs/scene/BVHBuilder";
export * from "../wgs/scene/SceneMath";
export * from "../wgs/scene/MemoryTracker";

export * from "../wgs/scene/out-of-core-tile-manager/OutOfCoreTileManager";
export * from "../wgs/scene/out-of-core-tile-manager/BvhNode";
export * from "../wgs/scene/out-of-core-tile-manager/tasks/OutOfCoreTaskBase";
export * from "../wgs/scene/out-of-core-tile-manager/BvhCompute";

export * from "../wgs/scene/leaflet/TileCoords";
export * from "../wgs/scene/leaflet/ModelIteratorTexQuad";

//TODO: Do all these need to be exported or just the entry point?
export * from "../wgs/scene/consolidation/FragmentListConsolidation"; // name exported differs
export * from "../wgs/scene/consolidation/ConsolidationIterator";
export * from "../wgs/scene/consolidation/InstanceBufferBuilder";
export * from "../wgs/scene/consolidation/Consolidation";
export * from "../wgs/scene/consolidation/GeomMergeTask";

export * from "../file-loaders/lmvtk/common/VertexBufferBuilder";
export * from "../file-loaders/lmvtk/otg/OtgGeomCodec";
export * from "../file-loaders/lmvtk/otg/HashStrings";
export * from "../file-loaders/lmvtk/common/custom-properties/PropertyHash";
export * from "../file-loaders/lmvtk/f2d/F2d";
export * from "../file-loaders/lmvtk/common/Propdb";

export * from "../file-loaders/net/Xhr";

export { DDSLoader } from "../../thirdparty/three.js/DDSLoader";
export { patchShader } from "../../thirdparty/three.js/materials/PatchShader";


export * from "../application/LightPresets";
export * from "../application/ModelLayers";
export * from "../application/LocalStorage";
export * from "../application/Preferences";
export * from "../application/PreferenceNames";
export * from "../application/Viewer3DImpl";
export * from "../application/ViewerState";

import { FeatureFlags as _FeatureFlags, PublicFeatureFlags as _PublicFeatureFlags, InternalFeatureFlags as _InternalFeatureFlags } from "../application/FeatureFlags";
export const InternalFeatureFlags = _InternalFeatureFlags;

export * from "../measurement/UnitFormatter";

export * from "../measurement/UnitParser";
export * from "../measurement/DisplayUnits";

//Animation
export * from "../animation/Animation";
export * from "../animation/KeyFrameAnimator";
export * from "../animation/type/MeshAnimation";

// Loaders
export * from "../file-loaders/main/constants";
export * from "../file-loaders/main/SvfLoader";
export * from "../file-loaders/main/F2DLoader";
export * from "../file-loaders/main/LeafletLoader";
export * from "../file-loaders/main/PropDbLoader";
export * from "../file-loaders/main/TextureLoader";
export * from "../file-loaders/main/OtgLoader";
export * from "../file-loaders/main/OtgResourceCache";
export * from "../file-loaders/main/Empty2DModelLoader";
export * from "../file-loaders/rcs/RcsFileLoader";

export * from "../tools/Selector";
export { CompositeSet } from "../tools/CompositeSet";
export * from "../tools/VisibilityManager"; // Required by a viewer extension (VIZX-2894)
export * from "../tools/MultiModelVisibilityManager"; // Required by a viewer extension (VIZX-2894)
export * from "../tools/viewtransitions/ViewTransition";
export * from "../tools/FunctionIntrusion";

export * from "../tools/TransformControls";
export * from "../tools/TransformGizmos";
export * from "../tools/SectionTransformControls";

export * from "../file-loaders/main/WorkerCreator";
export * from "../file-loaders/workers/WorkerPool";import * as _RcsConstants from

"../file-loaders/rcs/RcsConstants";export { _RcsConstants as RcsConstants };

export { renderBudgetManager } from "../application/RenderBudgetManager";

// Conditionally import GUI files
export * from "./conditional/gui/avp";

// Register extensions bundled into their own JS files
export * from "../../extensions/registerExternalExtensions";

import { EventUtils } from '../application/EventUtils.js';
export const isMiddleClick = EventUtils.isMiddleClick;
export const isRightClick = EventUtils.isRightClick;

export const ENABLE_DEBUG = globalThis.ENABLE_DEBUG;

// Reexported libraries
export { default as DOMPurify } from 'dompurify';